import {Component, OnInit} from '@angular/core';
import {UtilityService} from "../../utility.service";
import {FireService} from "../../fire.service";
import {Skill} from "../../models/Skill";

@Component({
  selector: 'app-skills',
  templateUrl: './skills.component.html',
  styleUrls: ['./skills.component.css'],
})
export class SkillsComponent implements OnInit {

  color: string[] = ['#000', '#000', '#000'];
  data: Skill[] = [];

  constructor(private utility: UtilityService, private fireService: FireService) {}

  ngOnInit() {
    this.getRandomColors();
    this.fireService.getSkills(items => this.data = items);
  }

  getRandomColors() {
    this.color = this.color.map(
      this.utility.getRandomItemBGColor,
      this.utility);
  }

}



// WEBPACK FOOTER //
// F:/Home/Locker/About-me/about-me1/src/app/displayer/skills/skills.component.ts